// Single Service Plan lifecycle presentation used by board surfaces and the Manage header.
import { EntitySubStatus, ServicePlan } from '@jms/model';
import type { StatusTag } from '../../shared/define.status.tag';
import { statusToneStyle, StatusTone } from '../../shared/status.tag.tones';

export const servicePlanStatusTag: StatusTag<ServicePlan> = value => {

  const status = value as EntitySubStatus | null | undefined;
  if (!status) return null;
  const systemName = status.systemName ?? status.name;
  const tones: Record<string, StatusTone> = { Draft: 'neutral', Started: 'success', Paused: 'warning', Archived: 'neutral' };
  const labels: Record<string, string> = { Started: 'Active - Started', Paused: 'Active - Paused' };
  return { label: labels[systemName] ?? status.name ?? systemName, ...statusToneStyle(tones[systemName] ?? 'brand') };
};
